import React from "react";
import Main from "../components/Main";
import SlopeChartFactors from "../components/SlopeChartFactors";
import { factors } from "../data/chartData";

export default class extends React.Component {
  render() {
    return (
      <div>
        <Main>
          <SlopeChartFactors 
            data={factors}
            width={this.props.width} />
        </Main>

        <style jsx global>{`
          html, body {
            height: 100%
          }

          body {
            background: #fff;
            margin: 0;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-font-smoothing: grayscale;
          }
        `}</style>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/slope-factors.js